module.exports = __webpack_public_path__ + "img/可穿戴设备.39f8df87.png";